var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { sanitizeBaseUrl, setUsersDeviceStatus } from "../../../utils";
import { assignCustomerToInventoryItem, disInventoryItemCodeValidation, diSv1RegisterInventoryItem, getDisInventoryItem, getDisInventoryItemForUser, registerInventoryItemForGuest, unregisterInventoryItemForConsumer, unregisterInventoryItemForGuest, } from "../../evo-client/__generated__";
import { createClient, createConfig } from "../../evo-client/__generated__/client";
import { getDeviceDataFromEvoResponse } from "../utils/getDeviceDataFromEvoResponse";
export class DeviceApiEvo {
    constructor(deviceServiceUrl, tenantToken, recaptchaId, ciamToken, jwtToken) {
        this.tenantToken = tenantToken;
        this.recaptchaId = recaptchaId;
        this.ciamToken = ciamToken;
        this.jwtToken = jwtToken;
        this.client = createClient(createConfig({ baseUrl: sanitizeBaseUrl(deviceServiceUrl), throwOnError: true }));
    }
    registerDeviceToGuest(deviceId, guestIdentifier) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data, response } = yield registerInventoryItemForGuest({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-SERVICE-AUTHENTICATION": this.jwtToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                body: {
                    deviceId,
                    externalId: guestIdentifier,
                },
            });
            return Promise.resolve({
                code: (data === null || data === void 0 ? void 0 : data.code) || "",
                data: getDeviceDataFromEvoResponse(data === null || data === void 0 ? void 0 : data.data),
                message: (_a = data === null || data === void 0 ? void 0 : data.message) !== null && _a !== void 0 ? _a : null,
                statusCode: response.status,
            });
        });
    }
    unassignDeviceFromGuest(deviceId, externalId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { data, response } = yield unregisterInventoryItemForGuest({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-RECAPTCHA-TOKEN": "",
                    "X-DES-SERVICE-AUTHENTICATION": this.jwtToken,
                },
                path: {
                    code: deviceId,
                },
                body: {
                    externalId,
                },
            });
            return Promise.resolve({
                code: (data === null || data === void 0 ? void 0 : data.code) || "",
                data: {
                    deviceIdentifier: ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.deviceIdentifier) || "",
                },
                message: (data === null || data === void 0 ? void 0 : data.message) || "",
                statusCode: response.status,
            });
        });
    }
    assignDeviceToUser(deviceId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { data, response } = yield assignCustomerToInventoryItem({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-SERVICE-AUTHENTICATION": this.jwtToken,
                    "X-DES-RECAPTCHA-TOKEN": "",
                },
                path: {
                    code: deviceId,
                },
                body: {
                    consumerId: userId || "",
                },
            });
            return Promise.resolve({
                code: (data === null || data === void 0 ? void 0 : data.code) || "",
                data: getDeviceDataFromEvoResponse(data === null || data === void 0 ? void 0 : data.data),
                message: (_a = data === null || data === void 0 ? void 0 : data.message) !== null && _a !== void 0 ? _a : null,
                statusCode: response.status,
            });
        });
    }
    checkDeviceIdForRegistration(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            yield disInventoryItemCodeValidation({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                    "X-DES-SERVICE-AUTHENTICATION": this.jwtToken,
                },
                path: {
                    code: id,
                },
            });
        });
    }
    deleteDevice(id, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield unregisterInventoryItemForConsumer({
                client: this.client,
                headers: {
                    "X-DES-SERVICE-AUTHENTICATION": this.jwtToken,
                    "X-DES-TENANT": this.tenantToken,
                },
                path: {
                    code: id,
                },
                body: {
                    consumerId: userId || "",
                },
            });
            return this.myDevices(userId);
        });
    }
    myDevices(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const { data, response } = yield getDisInventoryItemForUser({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-SERVICE-AUTHENTICATION": this.jwtToken,
                    "X-DES-CONSUMER-IAM-TOKEN": this.ciamToken,
                },
                query: {
                    userId,
                },
            });
            const hasUserDevices = Array.isArray(data === null || data === void 0 ? void 0 : data.data) && data.data.length > 0;
            setUsersDeviceStatus(hasUserDevices);
            return Promise.resolve({
                data: (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.map(getDeviceDataFromEvoResponse)) !== null && _b !== void 0 ? _b : [],
                message: (_c = data === null || data === void 0 ? void 0 : data.message) !== null && _c !== void 0 ? _c : null,
                statusCode: response.status,
            });
        });
    }
    getDevice(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, response } = yield getDisInventoryItem({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-SERVICE-AUTHENTICATION": this.jwtToken,
                    "X-DES-CONSUMER-IAM-TOKEN": this.ciamToken,
                },
                path: {
                    code: id,
                },
            });
            const convertedResponseData = data;
            if (!(convertedResponseData === null || convertedResponseData === void 0 ? void 0 : convertedResponseData.data)) {
                return Promise.reject(new Error("Device not found"));
            }
            return Object.assign(Object.assign({}, convertedResponseData), { statusCode: response.status });
        });
    }
    registerDevice(registrationCode, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { data, response } = yield diSv1RegisterInventoryItem({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-SERVICE-AUTHENTICATION": this.jwtToken,
                    "X-DES-CONSUMER-IAM-TOKEN": this.ciamToken,
                },
                body: {
                    consumerId: userId || "",
                    deviceId: registrationCode,
                },
            });
            setUsersDeviceStatus(true);
            return Promise.resolve({
                code: (data === null || data === void 0 ? void 0 : data.code) || "",
                data: getDeviceDataFromEvoResponse(data === null || data === void 0 ? void 0 : data.data),
                message: (_a = data === null || data === void 0 ? void 0 : data.message) !== null && _a !== void 0 ? _a : null,
                statusCode: response.status,
            });
        });
    }
}
//# sourceMappingURL=DeviceApiEvo.js.map